export default
/* glsl */
"\n#ifdef USE_FOG\n\n\tvarying float fogDepth;\n\n#endif\n";